/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_No_DifferencesInputs */



/**
* | output |
* | --- |
* | "No differences" |
*
* @param {Compare_Event_Groups_No_DifferencesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_no_differences = /** @type {((inputs?: Compare_Event_Groups_No_DifferencesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_No_DifferencesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune différence")
	if (locale === "de") return /** @type {LocalizedString} */ ("Keine Unterschiede")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessuna differenza")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Различий нет.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay diferencias")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("没有差异")
	if (locale === "ja") return /** @type {LocalizedString} */ ("違いはありません")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई अंतर नहीं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sem diferenças")
	return /** @type {LocalizedString} */ ("No differences")
});